import { ClipboardPenLineIcon, SparklesIcon } from "lucide-react";
import { Button } from "../ui/button";

export interface ProjectLeadWelcomeProps {
  readonly projectTitle: string;
  readonly onPlanWork: () => void;
}

export function ProjectLeadWelcome({ projectTitle, onPlanWork }: ProjectLeadWelcomeProps) {
  return (
    <section
      aria-labelledby="project-lead-welcome-heading"
      className="space-y-5 border-b border-border pb-6"
    >
      <div className="flex items-start gap-3">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-md border border-border bg-muted text-foreground">
          <SparklesIcon className="size-4" aria-hidden />
        </div>
        <div className="min-w-0 space-y-1">
          <h2
            id="project-lead-welcome-heading"
            className="text-base font-semibold tracking-tight text-foreground"
          >
            What do you want to move forward?
          </h2>
          <p className="text-sm leading-5 text-muted-foreground">
            Describe the outcome you want to move forward in {projectTitle}. Project Lead prepares a
            reviewable plan; you decide what changes.
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-3 border-l border-border pl-4">
        <div className="flex flex-wrap items-center gap-3">
          <Button className="min-h-11 shrink-0 sm:min-h-8" size="sm" onClick={onPlanWork}>
            <ClipboardPenLineIcon aria-hidden /> Start planning
          </Button>
          <p className="max-w-sm text-xs leading-5 text-muted-foreground">
            Opens the task composer. It can prepare work and decisions, but never sends, assigns, or
            starts work without your approval.
          </p>
        </div>
      </div>
    </section>
  );
}
